var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      dialog: _vm.show,
      width: "800",
      title: _vm.$t("label_essweb_RosterRecord_dialog_errorMessageTitle"),
      maxWidth: "800",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: { headers: _vm.headers, items: _vm.desserts },
              scopedSlots: _vm._u([
                {
                  key: "item.position",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.cell))]
                  },
                },
                {
                  key: "item.message",
                  fn: function (ref) {
                    var item = ref.item
                    return [_vm._v(" " + _vm._s(item.msg))]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: {
                saveBtn: "",
                saveText: "label_essweb_rosterRecord_dialog_downErrorBtnLabel",
              },
              on: { save: _vm.toUrl, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }